import React, { FC, useCallback, useMemo } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import {
	PERMISSION_NAMES,
	isUserAllowedToAccess,
	isUserManagedBySupplier,
} from '../../utils/AuthUtils';
import OverviewShell from '../overview_shell/OverviewShell';

require('./AssetsOverviewPage.less');

const AssetsOverviewPage: FC<any> = ({
	history,
	currentUser,
	companyConfig,
	childRoutes,
	userType,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/assets/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const templatesVisible = useMemo(
		() =>
			isUserAllowedToAccess(currentUser.userType)(
				PERMISSION_NAMES.MODIFY_ASSET_TYPES,
				companyConfig,
				currentUser.roles
			),
		[companyConfig, currentUser.roles, currentUser.userType]
	);

	const isNotSupplierManaged = useMemo(() => !isUserManagedBySupplier(currentUser), []);

	const tabs = useMemo(
		() => [
			{
				key: 'all',
				name: 'All',
			},
			...(templatesVisible && isNotSupplierManaged
				? [
						{
							key: 'templates/overview',
							name: 'Types',
						},
				  ]
				: []),
			...(isNotSupplierManaged
				? [
						{
							key: 'downtime',
							name: 'Downtime',
						},
				  ]
				: []),
			// `checkTabActive` is a substring match, and 'refrigerant' is a prefix of the Event Log
			// route too, so the tab stays lit across both sub-routes.
			{
				key: 'refrigerant',
				name: 'Refrigerant Tracking',
			},
		],
		[templatesVisible, isNotSupplierManaged]
	);

	return (
		<>
			<Route
				path={`/${userType}/assets/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/assets/overview/all`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Assets"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="assetsPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

const ComponentWithoutUserType = withRouter(connect(mapStateToProps, null)(AssetsOverviewPage));

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
